export class CalculatorModel {
    product: string;
    currencyCode: string;
    sellType: string;
    amount: number;
    cardRate: number;
    rate: number;
    inrAmount: number;
    commission: number;
    min: number;
    max: number;
    discount: number;
    nrr: number;
    revenueModel: string;
    baseRateInINR: number;
    revenueSharePercentage: number
}


// WEBPACK FOOTER //
// ./src/app/_models/rates/CalculatorModel.ts